export default {
  zh: {
    find:"Find",
    inviteHistory:"Invite History",
    inviteID:"Inviter ID",
    invitees:"Invitees",
    timeInvited:"Time Invited",
    id:"ID",
    enterID:"Enter the account ID",
    notExist:"The user does not exist",
    successful:"The operation was successful",
    banText:"Are you sure you want to reset?",
    haveHost:"The user joined another guild",
    invite:"Invite",
    removeText:"Are you sure to remove it?",
    yes: "confirm",
    no: "cancel",
    poaloder:'Enter reason',
    reason:"Reason",
    resetRoomData:"Reset room data",
    removeList:"Remove from homepage recommendation list",
  },
  en: {
    find:"Find",
    inviteHistory:"Invite History",
    inviteID:"Inviter ID",
    invitees:"Invitees",
    timeInvited:"Time Invited",
    id:"ID",
    enterID:"Enter the account ID",
    notExist:"The user does not exist",
    successful:"The operation was successful",
    banText:"Are you sure you want to reset?",
    haveHost:"The user joined another guild",
    invite:"Invite",
    removeText:"Are you sure to remove it?",
    yes: "confirm",
    no: "cancel",
    poaloder:'Enter reason',
    reason:"Reason",
    resetRoomData:"Reset room data",
    removeList:"Remove from homepage recommendation list",
    reset:"Reset",
    nohad:'No ban permission',
  },
  ar: { // 阿拉伯
    find:"وجد",
    inviteHistory:"دعوة السجل",
    inviteID:"ايدي المدعو",
    invitees:"المدعوون ",
    timeInvited:"وقت الدعوة ",
    id:"معرف",
    enterID:"ادخل ايدي الحساب",
    notExist:"المستخدم غير موجود",
    successful:"العملية كانت ناجحه",
    haveHost:"انضم المستخدم إلى نقابة أخرى",
    invite:" يدعو",
    banText:"هل أنت متأكد أنك تريد إعادة تعيين؟",
    removeText:"هل أنت متأكد من إزالته؟",
    yes: "أكد",
    no: "إلغاء",
    poaloder:'أدخل السبب',
    reason:"السبب",
    resetRoomData:"إعادة ضبط بيانات الغرفة",
    removeList:"إزالة من قائمة توصيات الصفحة الرئيسية",
    reset:"إعادة ضبط",   
    nohad:'لا يوجد إذن الحظر',
  },
  tr:{ //土耳其
    find:"Bul",
    inviteHistory:"Davet Geçmişi",
    inviteID:"Davet Eden Kimliği",
    invitees:"Davetliler",
    timeInvited:"Davet Edilen Zaman",
    id:"KİMLİĞİ",
    enterID:"Hesap ID Girin",
    notExist:"Kullanıcı mevcut değil",
    successful:"İşlem Başarılı Oldu",
    haveHost:"Kullanıcı başka bir loncaya katıldı",
    invite:"Davet Et",
    banText:"Bilgileri sıfırlamak istediğinizden emin misiniz?",
    removeText:"Kaldıracağınızdan emin misiniz?",
    yes: "onaylamak",
    no: "iptal etmek",
    poaloder:'Nedenini Girin',
    reason:"Sebep",
    resetRoomData:"Oda verilerini sıfırla",
    removeList:"Ana sayfa öneri listesinden kaldır",
    reset:"Sıfırla",
    nohad:'Ban izni yok',
  },
  pt:{
    "find": "Encontrar",
    "inviteHistory": "Histórico de convites",
    "inviteID": "ID do convidado",
    "invitees": "Convidados",
    "timeInvited": "Hora do convite",
    "id": "ID",
    "enterID": "Digite o ID da conta",
    "notExist": "O usuário não existe",
    "successful": "A operação foi bem-sucedida",
    "banText": "Tem certeza de que deseja redefinir?",
    "haveHost": "O usuário entrou em outro guilda",
    "invite": "Convidar",
    "removeText": "Tem certeza de que deseja remover?",
    "yes": "confirmar",
    "no": "cancelar",
    "poaloder": "Digite o motivo",
    "reason": "Motivo",
    "resetRoomData": "Redefinir dados da sala",
    "removeList": "Remover da lista de recomendações da página inicial",
    "reset": "Redefinir",
    "nohad": "Sem permissão para banir"
},
  id:{
    "find": "Temukan",
    "inviteHistory": "Riwayat Undangan",
    "inviteID": "ID Pengundang",
    "invitees": "Undangan",
    "timeInvited": "Waktu Diundang",
    "id": "ID",
    "enterID": "Masukkan ID akun",
    "notExist": "Pengguna tidak ada",
    "successful": "Operasi berhasil",
    "banText": "Apakah Anda yakin ingin mengatur ulang?",
    "haveHost": "Pengguna bergabung dengan guild lain",
    "invite": "Undang",
    "removeText": "Apakah Anda yakin ingin menghapusnya?",
    "yes": "konfirmasi",
    "no": "batalkan",
    "poaloder": "Masukkan alasan",
    "reason": "Alasan",
    "resetRoomData": "Setel ulang data ruang",
    "removeList": "Hapus dari daftar rekomendasi beranda",
    "reset": "Setel ulang",
    "nohad": "Tidak ada izin untuk memblokir"
},
  uz:{
    "find": "Topish",
    "inviteHistory": "Taklif Tarixi",
    "inviteID": "Taklifchi ID",
    "invitees": "Taklif qilinganlar",
    "timeInvited": "Taklif Qilingan Vaqt",
    "id": "ID",
    "enterID": "Hisob ID sini kiriting",
    "notExist": "Foydalanuvchi mavjud emas",
    "successful": "Operatsiya muvaffaqiyatli amalga oshirildi",
    "banText": "Qayta tiklashni xohlaysizmi?",
    "haveHost": "Foydalanuvchi boshqa guildga qo'shildi",
    "invite": "Taklif qilish",
    "removeText": "Buni olib tashlashni xohlaysizmi?",
    "yes": "tasdiqlash",
    "no": "bekor qilish",
    "poaloder": "Sababni kiriting",
    "reason": "Sabab",
    "resetRoomData": "Xona ma'lumotlarini tiklash",
    "removeList": "Bosh sahifa tavsiyalar ro'yxatidan o'chirish",
    "reset": "Qayta tiklash",
    "nohad": "Bloklash huquqi yo'q"
},
  ru:{
    "find": "Найти",
    "inviteHistory": "История приглашений",
    "inviteID": "ID пригласившего",
    "invitees": "Приглашенные",
    "timeInvited": "Время приглашения",
    "id": "ID",
    "enterID": "Введите ID аккаунта",
    "notExist": "Пользователь не существует",
    "successful": "Операция успешна",
    "banText": "Вы уверены, что хотите сбросить?",
    "haveHost": "Пользователь присоединился к другому гильдии",
    "invite": "Пригласить",
    "removeText": "Вы уверены, что хотите удалить?",
    "yes": "подтвердить",
    "no": "отмена",
    "poaloder": "Введите причину",
    "reason": "Причина",
    "resetRoomData": "Сбросить данные комнаты",
    "removeList": "Удалить из списка рекомендаций на главной странице",
    "reset": "Сбросить",
    "nohad": "Нет прав на блокировку"
},
  fa:{
    "find": "یافتن",
    "inviteHistory": "تاریخ دعوت",
    "inviteID": "شناسه دعوت کننده",
    "invitees": "دعوت شده‌ها",
    "timeInvited": "زمان دعوت",
    "id": "شناسه",
    "enterID": "شناسه حساب کاربری را وارد کنید",
    "notExist": "کاربر وجود ندارد",
    "successful": "عملیات با موفقیت انجام شد",
    "banText": "آیا مطمئن هستید که می‌خواهید ریست کنید؟",
    "haveHost": "کاربر به یک گیلد دیگر پیوسته است",
    "invite": "دعوت",
    "removeText": "آیا مطمئن هستید که می‌خواهید آن را حذف کنید؟",
    "yes": "تأیید",
    "no": "لغو",
    "poaloder": "دلیل را وارد کنید",
    "reason": "دلیل",
    "resetRoomData": "داده‌های اتاق را ریست کنید",
    "removeList": "حذف از لیست پیشنهادات صفحه اصلی",
    "reset": "ریست",
    "nohad": "مجوز مسدود کردن وجود ندارد"
}




}


// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset-room/lang.js